import { LoginPage as SharedLoginPage } from '@shared/auth/LoginPage';

/**
 * Telemetry-branded login page.
 * Wraps the shared LoginPage component with the app-specific title.
 */
export function LoginPage() {
  return <SharedLoginPage title="kart.win" />;
}
